<template>
	<section class="vcx-section vcx-theme-dark vcx-pt-0 vcx-pb-500 vcx-pb-300-smo">
		<div class="vcx-container">
			<div class="vcx-grid">
				<VcxCommercial data-test="vcx-commercial" />
				<div
					v-if="!isMobile"
					data-test="vcx-democratizing-heading"
					class="vcx-col-12 vcx-col-8-md vcx-col-offset-2-md"
				>
					<div class="vcx-flex vcx-flex-col vcx-text-center vcx-text-left-smo vcx-pt-500">
						<span class="vcx-label-eyebrow">Democratizing venture capital</span>
						<h2 class="vcx-h2 vcx-mt-300"
							>Everyday Americans are getting locked out of a once-in-a-generation wealth event</h2
						>
					</div>
				</div>
				<div
					v-if="!isMobile"
					data-test="vcx-democratizing-body"
					class="vcx-col-12 vcx-col-8-md vcx-col-offset-2-md vcx-col-6-lg vcx-col-offset-3-lg"
				>
					<div class="vcx-flex vcx-flex-col vcx-text-center vcx-text-left-smo vcx-pt-100">
						<p class="vcx-body-xl vcx-mb-100"
							>For generations, everyday Americans could be part of the companies that were driving the
							country forward.
						</p>
						<p class="vcx-body-xl vcx-mb-100"
							>However today, the most important technology companies are staying private longer, which
							means everyday investors are being left behind.</p
						>
						<p class="vcx-body-xl"
							>VCX changes that, giving individuals the ability to invest in tomorrow’s great technology
							companies today.</p
						>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '@stores/app';
import VcxCommercial from './vcx-commercial.vue';

const appStore = useAppStore();
const isMobile = computed(() => appStore.isMobile);
</script>
